import { WHAT_SETS_US_APART } from '../../constants';
import DashboardCard from '../../shared/DashboardCard';
import {
  SectionContainer,
  ContentContainer,
  SectionTitle,
  CardsStack,
  BottomText,
  ButtonStack,
} from './styles';
import CTAButton from '../../../../../ui/ctaButton';
import { openSimplePracticeConsultation } from '../../../../../utils/simplePractice';

const WhatSetsUsApartSection = () => {
  const handleBookConsultation = () => {
    openSimplePracticeConsultation();
  };

  return (
    <SectionContainer>
      <ContentContainer maxWidth="lg">
        <SectionTitle variant="h3">{WHAT_SETS_US_APART.title}</SectionTitle>

        <CardsStack>
          {WHAT_SETS_US_APART.cards.map((card, index) => (
            <DashboardCard
              key={index}
              title={card.title}
              description={card.description}
              reverse={card.reverse}
              image={card.image}
            />
          ))}
        </CardsStack>
      </ContentContainer>

      <BottomText>{WHAT_SETS_US_APART.bottomText}</BottomText>

      <ButtonStack>
        <CTAButton
          variant="contained"
          text={WHAT_SETS_US_APART.buttonText}
          onClick={handleBookConsultation}
        />
      </ButtonStack>
    </SectionContainer>
  );
};

export default WhatSetsUsApartSection;
